<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="adName" placeholder="请输入计划名称" style="width: 220px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="multiExecStatus" multiple collapse-tags filterable clearable placeholder="选择状态">
            <el-option v-for="item in statusList" :key="item.id" :value="item.id" :label="item.name" style="width: 180px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="adAccountIdList" multiple collapse-tags filterable clearable placeholder="选择账号">
            <el-option v-for="item in accountData" :key="item.id" :value="item.id" :label="item.name" style="width: 220px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="mediaIds" multiple collapse-tags filterable clearable placeholder="选择媒体">
            <el-option v-for="item in mediaData" :key="item.id" :value="item.id" :label="item.name" style="width: 180px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
const statusList = [
  { name: '成功', id: 1 },
  { name: '失败', id: -1 }
]
export default {
  name: 'listFilter',
  props: {
    accountData: {
      type: Array
    },
    mediaData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        adName: this.adName,
        multiExecStatus: this.multiExecStatus,
        adAccountIdList: this.adAccountIdList,
        mediaIds: this.mediaIds
      }
      this.$emit('on-change', params)
    }
  },
  data() {
    return {
      adName: '',
      mediaIds: [],
      adAccountIdList: [],
      multiExecStatus: [],
      statusList
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
